import { render, staticRenderFns } from "./XNestable.vue?vue&type=template&id=7070f975&"
import script from "./XNestable.vue?vue&type=script&lang=js&"
export * from "./XNestable.vue?vue&type=script&lang=js&"
import style0 from "./XNestable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports